import React, { useState, useMemo, useEffect } from 'react'
import { connect } from 'react-redux'

import { ORDER } from '../../../reduxs'
import CateringManagement from './CateringManagement'
import FacilityManagement from './FacilityManagement'
import OrderBottomBar from './OrderBottomBar'
import OrderManagerTab from './OrderManagerTab'
import OrderModalGroup from './OrderModalGroup'
import { ADD, EDIT, ORDER_MANAGER, ORDER_MODAL, SPACE_TYPE, STATUS } from '../../../helpers'

import { OrderManagerStyled } from './styles'
import { isEmpty } from 'lodash'

function OrderManager(props) {
  const [selectedTab, setSelectedTab] = useState(ORDER_MANAGER.VALUE.CATERING)
  const [selectedOrderTab, setSelectedOrderTab] = useState(ORDER_MODAL.VALUE.DRINK)

  const {
    language,
    getListCateringByCompanyId,
    companyId,
    bookingDetail,
  } = props

  const orderManagerTab = useMemo(() => {
    return {
      [ORDER_MANAGER.VALUE.CATERING]: {
        value: ORDER_MANAGER.VALUE.CATERING,
        title: ORDER_MANAGER.TAB.CATERING,
      },
      [ORDER_MANAGER.VALUE.EQUIPMENT]: {
        value: ORDER_MANAGER.VALUE.EQUIPMENT,
        title: ORDER_MANAGER.TAB.EQUIPMENT,
      },
      [ORDER_MANAGER.VALUE.FACILITY]: {
        value: ORDER_MANAGER.VALUE.FACILITY,
        title: ORDER_MANAGER.TAB.FACILITY,
      },
    }
  } , [])

  // Desk bookings have no catering or equipment, so only the facility tab is offered
  const isDesk = bookingDetail?.spaceType === SPACE_TYPE.DESK
  const activeTab = isDesk ? ORDER_MANAGER.VALUE.FACILITY : selectedTab
  const visibleTab = isDesk
    ? { [ORDER_MANAGER.VALUE.FACILITY]: orderManagerTab[ORDER_MANAGER.VALUE.FACILITY] }
    : orderManagerTab

  useEffect(() => {
    getListCateringByCompanyId(companyId)
  }, [])

  const {submitOrderText, editOrderText} = useMemo(() => {
    const resultText = {}

    if (selectedTab === ORDER_MANAGER.VALUE.CATERING) {
      resultText.submitOrderText = ADD[language] + ORDER_MANAGER.TAB.CATERING[language]
      resultText.editOrderText = EDIT[language] + ORDER_MANAGER.TAB.CATERING[language]
    } else if (selectedTab === ORDER_MANAGER.VALUE.EQUIPMENT) {
      resultText.submitOrderText = ADD[language] + ORDER_MANAGER.TAB.EQUIPMENT[language]
      resultText.editOrderText = EDIT[language] + ORDER_MANAGER.TAB.EQUIPMENT[language]
    }

    return resultText
  }, [selectedTab])

  return (
    <OrderManagerStyled>
      {!isEmpty(bookingDetail) &&
        <>
          <OrderManagerTab
            orderManagerTab={visibleTab}
            language={language}
            setSelectedTab={setSelectedTab}
            selectedTab={activeTab}
          />

          <OrderModalGroup
            language={language} 
            selectedTab={activeTab}
            setSelectedTab={setSelectedTab}
            selectedOrderTab={selectedOrderTab}
            orderManagerTab={orderManagerTab}
            setSelectedOrderTab={setSelectedOrderTab}
            editOrderText={editOrderText}
            submitOrderText={submitOrderText}
          />

          <div className='order-management__box'>
            {activeTab === ORDER_MANAGER.VALUE.FACILITY &&
              <FacilityManagement
                selectedTab={activeTab}
                orderManagerTab={orderManagerTab}
              />
            }

            {(activeTab === ORDER_MANAGER.VALUE.CATERING ||
              activeTab === ORDER_MANAGER.VALUE.EQUIPMENT) &&
              <CateringManagement
                selectedTab={activeTab}
                orderManagerTab={orderManagerTab}
              />
            }
          </div>

          <OrderBottomBar
            selectedTab={activeTab}
            orderManagerTab={orderManagerTab}
            language={language}
            submitOrderText={submitOrderText}
            disabled={bookingDetail.status === STATUS.END_MEETING}
          />
        </>
      }
    </OrderManagerStyled>
  )
}

const mapStateToProps = ({accountReducer, roomReducer, meetingReducer, orderReducer, modalReducer}) => {
  return {
    companyId: accountReducer.user.companyId,
    language: accountReducer.language,
    roomReducer,
    bookingDetail: meetingReducer.bookingDetail,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getListCateringByCompanyId: (params) => dispatch(ORDER.action.getListCateringByCompanyId(params)),
    confirmOrder: (selectedOrderTab) => dispatch(ORDER.action.confirmOrder(selectedOrderTab)),
    clearConfirmOrder: () => dispatch(ORDER.action.clearConfirmOrder()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderManager)
